import {
  Grid,
  makeStyles,
  Typography,
  Box,
  IconButton,
} from "@material-ui/core";
import React, { useEffect } from "react";
import { BsArrowUpRight } from "react-icons/bs";

const useStyles = makeStyles((theme) => ({
  newsCardBox: {
    position: "relative",
    "& .mainNewsBox": {
      background: "rgba(255, 255, 255, 0.03)",
      borderRadius: "10px",
      height: "100%",
      // width: "calc(100% - 57px)",
      margin: "0px 5px",
      position: "relative",
      "& .iconButton": {
        display: "none",
      },
      "&:hover": {
        "&::before": {
          top: "0",
          left: "0",
          width: "100%",
          height: "100%",
          content: "''",
          zIndex: "1",
          position: "absolute",
          backdropFilter: "blur(4px)",
          borderRadius: "10px",
          background: "rgba(255, 255, 255, 0.1)",
        },
        "& .iconButton": {
          top: "50%",
          left: "50%",
          display: "block",
          zIndex: "999",
          position: "absolute",
          background: "rgba(255, 255, 255, 0.1)",
          fontSize: "38px",
          transform: "translate(-50%, -50%)",
        },
      },
      "& p": {
        color: "rgba(255, 255, 255, 0.6)",
      },
    },
  },
}));

export default function NewsCards({ value, index }) {
  const classes = useStyles();

  const updateDimensions = () => {
    var offsetWidth = document.getElementById("imagecard" + index).offsetWidth;
    var newoofsetWidth = offsetWidth - 10;
    document.getElementById("imagecard" + index).style.height =
      newoofsetWidth + "px";
  };

  useEffect(() => {
    updateDimensions();
  }, [value, index]);
  useEffect(() => {
    window.addEventListener("resize", updateDimensions);
    return () => window.removeEventListener("resize", updateDimensions);
  }, []);

  return (
    <Box
      className={`${classes.newsCardBox}  maxHeightlength`}
      id={`imagecard${index}`}
    >
      <Box className="mainNewsBox">
        <Box style={{ padding: "15px" }}>
          <IconButton className="iconButton" target="_blank" href={value?.link}>
            <BsArrowUpRight />
          </IconButton>
          <Box mt={1} mb={2}>
            <Typography
              variant="h4"
              color="primary"
              style={{ wordWrap: "break-word" }}
            >
              {value?.title}
            </Typography>
          </Box>
          <Typography variant="body1">
            <div
              dangerouslySetInnerHTML={{
                __html:
                  value?.description?.length > 200
                    ? `${value?.description.slice(0, 200)}....`
                    : value?.description,
              }}
            />
          </Typography>
        </Box>
      </Box>
    </Box>
  );
}
